export default class inventoryUser {
	constructor() {
		this.id = null
		this.state = null
		this.users_permissions_user = null
	}
}